import { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import DigitalAgencyPage from './components/Pages/DigitalAgencyPage';
import BlogPage from './components/Pages/BlogPage';
import BlogListPage from './components/Pages/BlogListPage';
import BlogDetailsPage from './components/Pages/BlogDetailsPage';
import PortfolioPage from './components/Pages/PortfolioPage';
import PortfolioDetailsPage from './components/Pages/PortfolioDetailsPage';
import CaseStudyDetailsPage from './components/Pages/CaseStudyDetailsPage';
import ContactPage from './components/Pages/ContactPage';

import ErrorPage from './components/Pages/ErrorPage';
import AboutPage from './components/About/AboutPage';
import ThemeSelector from './components/ThemeSelector/ThemeSelector';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

function App() {
  const { pathname } = useLocation();
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : false;
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <>
      <LoadingScreen />
      <ThemeSelector isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
      <Routes>
        <Route path="/" element={<Layout darkMode={isDarkMode} />}>
          <Route index element={<DigitalAgencyPage darkMode={isDarkMode} />} />
          <Route path="digital-agency" element={<DigitalAgencyPage darkMode={isDarkMode} />} />
          <Route path="service/:serviceDetailsId" />
          <Route path="about" element={<AboutPage darkMode={isDarkMode} />} />
          <Route path="blog" element={<BlogPage darkMode={isDarkMode} />} />
          <Route path="blog-list" element={<BlogListPage darkMode={isDarkMode} />} />
          <Route path="blog/:blogDetailsId" element={<BlogDetailsPage darkMode={isDarkMode} />} />
          <Route path="portfolio" element={<PortfolioPage darkMode={isDarkMode} />} />
          <Route path="portfolio/:portfolioDetailsId" element={<PortfolioDetailsPage darkMode={isDarkMode} />} />
          <Route path="case-study-details" element={<CaseStudyDetailsPage darkMode={isDarkMode} />} />
          <Route path="contact" element={<ContactPage darkMode={isDarkMode} />} />
        </Route>
 
        {/* Start Light Mode */}
        <Route path="/light/" element={<Layout />}>
          <Route index element={<DigitalAgencyPage />} />
          <Route path="digital-agency" element={<DigitalAgencyPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="service/:serviceDetailsId" />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-list" element={<BlogListPage />} />
          <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio/:portfolioDetailsId" element={<PortfolioDetailsPage />} />
          <Route path="case-study-details" element={<CaseStudyDetailsPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>

        {/* End Light Mode */}
        <Route path="*" element={<ErrorPage darkMode={isDarkMode} />} />
      </Routes>
    </>
  );
}

export default App;